import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledHeader = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    height: 57px;
    padding: 0 8px 0 16px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;

export const ChartContainer = styled(Flex)`
    justify-content: center;
    align-items: center;
    width: 256px;

    @media (min-width: 1920px) {
        width: 420px;
    }
`;
